var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 286 286",
    style: {
      enableBackground: "new 0 0 1020 286"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#57E3B8;}\n\t.st1{font-family:'Poppins';}\n\t.st2{font-size:98.6784px;}\n\t.st3{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000033362242083488263300000013633406149758718609_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Isolation_Mode"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250.3,226.4c0,19-15.6,34.6-34.6,34.6H62.9c-19,0-34.6-15.6-34.6-34.6V73.6c0-19,15.6-34.6,34.6-34.6h152.8 c19,0,34.6,15.6,34.6,34.6L250.3,226.4L250.3,226.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M204.8,90.6l-16,27.7c-0.4,0.7-1.3,0.9-1.9,0.5l-6.2-3.6c-0.7-0.4-0.9-1.3-0.5-1.9l16-27.7 c0.4-0.7,1.3-0.9,1.9-0.5l6.2,3.6C205,89,205.2,89.9,204.8,90.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M226.4,139.8l-31.6,4.7c-0.8,0.1-1.5-0.4-1.6-1.2l-1.1-7.1c-0.1-0.8,0.4-1.5,1.2-1.6l31.6-4.7 c0.8-0.1,1.5,0.4,1.6,1.2l1.1,7.1C227.8,138.9,227.2,139.6,226.4,139.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M221.2,185.5l-27.7-16c-0.7-0.4-0.9-1.3-0.5-1.9l3.6-6.2c0.4-0.7,1.3-0.9,1.9-0.5l27.7,16 c0.7,0.4,0.9,1.3,0.5,1.9l-3.6,6.2C222.8,185.7,221.9,185.9,221.2,185.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M62.4,153.8c3.8,15.4,7.6,30.3,11.3,45.2c-8.4,0.4-16.2-6.1-19.6-15.7C49.8,171.3,52.5,161,62.4,153.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M157.3,85.2c-11-1.5-11.8,11-25.2,28.8c-7.2,9.5-18.3,14.8-27.2,17.7l-2.7,0.6l-25.6,6.1 c-5.4,1.3-8.7,6.7-7.4,12.1l11,46.3c1.3,5.4,6.7,8.7,12.1,7.4l22.9-5.4l7.8-1.8c9-1.7,20.8-2.3,31.3,2.2 c20.5,8.8,27.3,19.3,36.2,12.6C199.4,204.9,169,86.7,157.3,85.2z M151.1,140.9c2.8,0,5.1,2.3,5.1,5.1s-2.3,5.1-5.1,5.1 s-5.1-2.3-5.1-5.1S148.3,140.9,151.1,140.9z M135.2,140.9c2.8,0,5.1,2.3,5.1,5.1s-2.3,5.1-5.1,5.1s-5.1-2.3-5.1-5.1 C130.1,143.2,132.4,140.9,135.2,140.9z M140.8,182.9c-12-1.8-23.7-14.4-21.9-26.4l43.6,6.5C160.6,175,152.8,184.7,140.8,182.9z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Isolation_Mode_00000087403960505986899660000008601126816553163935_"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d32bef6307f7377b6c1a4e690d483bb8.svg";
export { ForwardRef as ReactComponent };